import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import ChatRoom from '@components/chat/ChatRoom';
import OutlookButton from '@components/outlook/OutlookButton';

import { IContentGalleryHeader } from '@base/outlookModel';
import { addDuration, isBefore } from '@utils/date';

const groupCurationCSS = css`
  display: flex;
  flex-direction: column;

  .chat-room-container {
    padding: ${Spacing.small}px ${Spacing.small}px;
  }
  .chat-room-header {
    margin-left: ${Spacing.medium}px;
  }
`;

export interface ProfileWithMessageProps {
  data: IContentGalleryHeader;
  onClickProfile: (id: number) => void;
  onClickButton?: () => void;
}

const ProfileWithMessage = ({
  data,
  onClickProfile,
  onClickButton,
}: ProfileWithMessageProps) => {
  const isNewCharacter =
    (data?.payload?.released_at &&
      isBefore(
        new Date(),
        addDuration(new Date(data?.payload?.released_at), { days: 3 })
      )) ||
    false;

  const chatRoomInfo = {
    characterName: data.title,
    image: data.image,
    lastMessage:
      data.sub_title?.length > 25
        ? data.sub_title.slice(0, 22) + '...'
        : data.sub_title,
    id: data.id as number,
  };

  const handleClickButton = (id: number) => {
    if (onClickButton) {
      onClickButton();
    } else {
      onClickProfile(id);
    }
  };

  return (
    <div css={groupCurationCSS}>
      <ChatRoom
        chatRoomInfo={chatRoomInfo}
        onClickAvatar={() => onClickProfile(data.id)}
        isNewCharacter={isNewCharacter}
        right={
          <OutlookButton
            text={data.button.text}
            type={data.button.type}
            onClickButton={() => handleClickButton(data.id)}
          />
        }
      />
    </div>
  );
};

export default ProfileWithMessage;
